module.exports = __webpack_public_path__ + "img/煤炭集团企业财务共享中心实践—河南能源义马煤业集团股份有限公司—1-1.5632dd8f.jpg";